export const textSizes = {
    headerLarge: {
        labelKey: "components.rich_text_editor.text_size.header_large",
        styles: "text-[40px] leading-[56px] font-bold",
        className: "text-size-header-large",
    },
    headerSmall: {
        labelKey: "components.rich_text_editor.text_size.header_small",
        styles: "text-[32px] leading-[40px] font-bold",
        className: "text-size-header-small",
    },
    subheader: {
        labelKey: "components.rich_text_editor.text_size.subheader",
        styles: "text-[24px] leading-[32px] font-bold",
        className: "text-size-subheader",
    },
    bodyLarge: {
        labelKey: "components.rich_text_editor.text_size.body_large",
        styles: "text-[18px] leading-[28px] font-normal",
        className: "text-size-body-large",
    },
    bodyMedium: {
        labelKey: "components.rich_text_editor.text_size.body_medium",
        styles: "text-[16px] leading-[24px] font-normal",
        className: "text-size-body-medium",
    },
    bodySmall: {
        labelKey: "components.rich_text_editor.text_size.body_small",
        styles: "text-[14px] leading-[20px] font-normal",
        className: "text-size-body-small",
    },
    footer: {
        labelKey: "components.rich_text_editor.text_size.footer",
        styles: "text-[12px] leading-[16px] font-normal",
        className: "text-size-footer",
    },
};
export const getTextSizeClassName = (textSize) => textSizes[textSize].className;
//# sourceMappingURL=TextSizeUtils.js.map